<template>
    <div class="customer_week_report_header">
        <div class="content">
            <div class="logo">
                <h1>舆情资讯</h1>
                <p>Daily Compliance News</p>
            </div>
            <!-- <slot></slot> -->
            <div class="show_date" v-if="showDate">
                <ShowYear :yearList="dateStore.yearList" />
                <ShowMonth style="margin-left: 57px" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { apiWeeklyWeek } from "@/request/api";
import ShowYear from "@/components/customer-week-report/pc/ShowYear.vue";
import ShowMonth from "@/components/customer-week-report/pc/ShowMonth.vue";
import useDateStore from "@/store/modules/useDate";

defineProps({ showDate: { type: Boolean, default: false } });
const dateStore = useDateStore();

// 获取周字典
async function setWeekDict() {
    if (dateStore.yearList.length) return; // 已存在年份列表，不重复获取
    const { data } = await apiWeeklyWeek();
    const res = [...new Set(data?.map((item) => item.year) || [])];
    dateStore.setYearList(res || []);
}

setWeekDict();
</script>

<style lang="scss" scoped>
.customer_week_report_header {
    width: 100%;
    height: var(--week-pc-header-height);
    background: url(~@/assets/img/customer-week-report/header_bg.png) no-repeat center;

    .content {
        width: 1080px;
        height: 100%;
        margin: 0 auto;
        display: flex;
        position: relative;

        .logo {
            width: 280px;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            // background: url(~@/assets/img/customer-week-report/logo.png) no-repeat center;

            h1 {
                font-size: 44px;
                color: var(--week-primary-color);
                margin-bottom: 9px;
                line-height: 1em;
                font-weight: bold;
            }

            p {
                font-size: 17px;
                color: var(--week-primary-color);
                font-weight: bold;
            }
        }
        .show_date {
            border-top: 1px solid var(--week-primary-color);
            position: absolute;
            top: 60px;
            right: 44px;
            padding-top: 30px;
            padding-right: 100px;
            padding-left: 10px;
            display: flex;
            align-items: center;
        }
    }
}
</style>
